export default __webpack_public_path__ + "static/media/mural2.09a47a39.jpg";